import { usePermissions } from "@/hooks/usePermissions";
import { Box, Divider, Typography } from "@mui/material";
import Cookies from "js-cookie";

export default function OrderStatusBreakdown({
  data,
  lastOrderData,
  singleColumn,
}: {
  data: any;
  lastOrderData: any;
  singleColumn?: boolean;
}) {
  const { currentUser, permissionLoading } = usePermissions();

  const currencySymbol =
    Cookies.get("mobile")
      ? JSON.parse(Cookies.get("mobile")!).currencySymbol
      : currentUser?.CompanyDetail?.CurrencySymbol ?? "";

  if (permissionLoading) return null;
  
  return (
    <Box
      sx={{
        bgcolor: "#fff",
        p: 2,
        mt: 3,
        borderRadius: 1,
        boxShadow: 1,
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          color: "#2e4734",
          fontSize: 16,
          mb: 2,
        }}
      >
        Order Status Breakdown
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: singleColumn ? "column" : "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 2,
          borderTop: "1px solid #ddd",
          pt: 1.5,
        }}
      >
        {/* Maximum Order */}
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ fontWeight: 600, color: "#2e4734" }}>
            Maximum Order
          </Typography>
          <Box sx={{display : "flex", justifyContent : "space-between"}}>
          <Box sx={{ mt: 1 }}>
            <Typography sx={{ fontSize: 13 }}>Order No.</Typography>
            <Typography sx={{ color: "blue", fontWeight: 600 }}>
              {data?.MaxOrderNumber}
            </Typography>
          </Box>
          <Box sx={{ mt: 1 }}>
            <Typography sx={{ fontSize: 13 }}>
              Value{`(${currencySymbol})`}
            </Typography>
            <Typography sx={{ color: "blue", fontWeight: 600 }}>
              {data?.MaxOrderByAmount}
            </Typography>
          </Box>
          </Box>
        </Box>

        {!singleColumn && <Divider orientation="vertical" flexItem />}

        {/* Minimum Order */}
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ fontWeight: 600, color: "#2e4734" }}>
            Minimum Order
          </Typography>
          <Box sx={{display : "flex", justifyContent : "space-between"}}>
          <Box sx={{ mt: 1 }}>
            <Typography sx={{ fontSize: 13 }}>Order No.</Typography>
            <Typography sx={{ color: "blue", fontWeight: 600 }}>
              {data?.MinOrderNumber}
            </Typography>
          </Box>
          <Box sx={{ mt: 1 }}>
            <Typography sx={{ fontSize: 13 }}>
              Value{`(${currencySymbol})`}
            </Typography>
            <Typography sx={{ color: "blue", fontWeight: 600 }}>
              {data?.MinOrderByAmount}
            </Typography>
          </Box>
          </Box>
        </Box>

        {!singleColumn && <Divider orientation="vertical" flexItem />}

        {/* Last Order */}
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ fontWeight: 600, color: "#2e4734" }}>
            Last Order
          </Typography>
          <Box sx={{display : "flex", justifyContent : "space-between"}}>
          <Box sx={{ mt: 1 }}>
            <Typography sx={{ fontSize: 13 }}>Order No.</Typography>
            <Typography sx={{ color: "blue", fontWeight: 600 }}>
              {lastOrderData?.LastOrderNumber}
            </Typography>
          </Box>
          <Box sx={{ mt: 1 }}>
            <Typography sx={{ fontSize: 13 }}>Value(₹)</Typography>
            <Typography sx={{ color: "blue", fontWeight: 600 }}>
              {lastOrderData?.LastOrderByAmount}
            </Typography>
          </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
